import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import ProjectPage from '../../components/ProjectPage'

const projectElements = {
	images: [
	  {
	    "src": "Parallelität/stadthalle",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/matraze",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/grafitti",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/hecke",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/netz",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/hauswand",
	    "orientation": "landscape"
	  },

	  {
	    "src": "Parallelität/feld",
	    "orientation": "landscape"
	  },
	  {
	    "src": "Parallelität/gitter",
	    "orientation": "landscape"
	  }
	]
}

export default class Flat extends React.Component{
	render(){
		return(
			<ProjectPage 
			title="Parallelität" 
			text={`Das Konzept dieser Fotoserie ist (wie auch dieser Text) sehr kurz und einfach: Flach erscheinende Sujets.`} 
			images={projectElements.images}/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/projects/flat.js